import {Styles} from "../Styles";
import useSquad from "../../../Provider/useSquad";
import {iActivePlayer} from "../Squad";

import React from "react";
import {PlayerSelectionStyle} from "./CurrentPlayerStyles";


export const CurrentPlayer = ({activePlayer}: { activePlayer: iActivePlayer }) => {

	const {users} = useSquad();

	return <Styles.Panel>
		<Styles.PanelTitle>Aktiver Spieler</Styles.PanelTitle>

		<Styles.Select
			value={activePlayer.id}
			onChange={_ => {
			}}
		>
			<option value={activePlayer.id}>
				{activePlayer.name}
			</option>

			{users
				.filter(player => player.id !== activePlayer.id)
				.map(player => (
					<option key={player.id} value={player.id}>
						{player.name}
					</option>
				))}
		</Styles.Select>

	</Styles.Panel>
};

/*
 * AKTIVER SPIELER
 * Nachbildung des DatenPad-Screenshots
 *
 * Referenzgröße: ca. 515 x 100 px
 * Farben: Dark Brown / Copper / Amber
 */


export const _CurrentPlayer = ({activePlayer}: { activePlayer: iActivePlayer }) => {

	const {users} = useSquad()

	return (
		<PlayerSelectionStyle.PlayerSection>
			<PlayerSelectionStyle.Inner>
				<PlayerSelectionStyle.SectionLabel htmlFor="datapad-active-player">
					Aktive Spieler
				</PlayerSelectionStyle.SectionLabel>

				<PlayerSelectionStyle.SelectFrame>
					<PlayerSelectionStyle.NativeSelect
						id="datapad-active-player"
						value={ activePlayer.id }
						onChange={ () => {} }
					>
						<option value={activePlayer.id}>
							{activePlayer.name}
						</option>

						{users
							.filter(player => player.id !== activePlayer.id)
							.map(player => (
								<option key={player.id} value={player.id}>
									{player.name}
								</option>
							))}
					</PlayerSelectionStyle.NativeSelect>

					<PlayerSelectionStyle.Chevron
						viewBox="0 0 16 16"
						aria-hidden="true"
					>
						<path d="M3 6 L8 11 L13 6"/>
					</PlayerSelectionStyle.Chevron>
				</PlayerSelectionStyle.SelectFrame>
			</PlayerSelectionStyle.Inner>
		</PlayerSelectionStyle.PlayerSection>
	);
}
